<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="testForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="test" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                testForm: () => import('../forms/TestForm'),
                test: () => import('../editViews/Test'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Test Group', value: 'testGroupId', table: 'testGroups', form: () => import('../forms/TestGroupForm') },
                    { text: 'Unit', value: 'unitId', table: 'units', form: () => import('../forms/UnitForm') },
                    { text: 'Format', value: 'formatId', table: 'formats', form: () => import('../forms/FormatForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    formats: [],
                    testGroups: [],
                    units: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "testGroupId", direction: "ascending" },
                    { column: "unitId", direction: "ascending" },
                    { column: "formatId", direction: "ascending" },
                ],
                itemsField: 'tests',
                editPageName: 'test',
                apiMethod: 'Tests',
                claimName: 'Tests',
                formTitle: 'Test',
                excelTitle: 'Tests',
                hasEditPage: true,
            }
        },
    };
</script>
